[
    {
        "ID": 101,
        "PACKAGE_ID": 101,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/vp2r/cdp/maps/ttc/1175/CP-TT-FCA.VP2R.UP-MAP.NAFTA.TTC-1175.1.zip"
    },
    {
        "ID": 102,
        "PACKAGE_ID": 102,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/giorgio/cdp/g2/mid/ttc/1176/MAP21411.bin"
    },
    {
        "ID": 103,
        "PACKAGE_ID": 103,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/giorgio/cdp/g2/high/ttc/1176/MAP21331.bin"
    },
    {
        "ID": 104,
        "PACKAGE_ID": 104,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/vp2r/cdp/maps/ttc/1175/CP-TT-FCA.VP2R.UP-MAP.NAFTA.TTC-1175.1.zip"
    },
    {
        "ID": 105,
        "PACKAGE_ID": 101,
        "NAME": "index.download_license",
        "URL_DESC": "https://download-cde.tomtom.com/cs/vp2r/cdp/maps/ttc/1175/USA_Canada_and_Mexico-105010.meta.dct"
    },
    {
        "ID": 106,
        "PACKAGE_ID": 102,
        "NAME": "index.download_license",
        "URL_DESC": "https://download-cde.tomtom.com/cs/giorgio/cdp/g2/mid/ttc/1176/USA_Canada_and_Mexico-105003.meta.dct"
    },
    {
        "ID": 107,
        "PACKAGE_ID": 103,
        "NAME": "index.download_license",
        "URL_DESC": "https://download-cde.tomtom.com/cs/giorgio/cdp/g2/high/ttc/1176/USA_Canada_and_Mexico-105003.meta.dct"
    },
    {
        "ID": 108,
        "PACKAGE_ID": 104,
        "NAME": "index.download_license",
      "URL_DESC": "https://download-cde.tomtom.com/cs/vp2r/cdp/maps/ttc/1175/USA_Canada_and_Mexico-105010.meta.dct"
    },
    {
        "ID": 109,
        "PACKAGE_ID": 105,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/my20/maps/nds/2026.06/MAP50471.bin"
    },
    {
        "ID": 111,
        "PACKAGE_ID": 107,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.ROW.NDS-22.1.0.zip"
    },
    {
        "ID": 112,
        "PACKAGE_ID": 108,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.EUR.NDS-21.1.0.zip"
    },
    {
        "ID": 113,
        "PACKAGE_ID": 109,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.ROW.NDS-22.1.0.zip"
    },
    {
        "ID": 114,
        "PACKAGE_ID": 110,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.ROW.NDS-22.1.0.zip"
    },
    {
        "ID": 115,
        "PACKAGE_ID": 111,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.NAM.NDS-23.2.0.zip"
    },
    {
        "ID": 116,
        "PACKAGE_ID": 112,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.ROW.NDS-22.1.0.zip"
    },
    {
        "ID": 117,
        "PACKAGE_ID": 113,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/psa/wave4/maps/nds/2026.06/RRMTMJBFUTT.20260817075051.tar"
    },
    {
        "ID": 118,
        "PACKAGE_ID": 114,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/my20/maps/nds/2023.12/MAP50423.bin"
    },
    {
        "ID": 119,
        "PACKAGE_ID": 115,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/my20/maps/nds/2023.12/MAP50420.bin"
    },
    {
        "ID": 120,
        "PACKAGE_ID": 116,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/my20/maps/nds/2023.12/MAP50423.bin"
    },
    {
        "ID": 121,
        "PACKAGE_ID": 117,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/my20/maps/nds/2023.12/MAP50423.bin"
    },
    {
        "ID": 122,
        "PACKAGE_ID": 118,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/my20/maps/nds/2023.12/MAP50423.bin"
    },
    {
        "ID": 123,
        "PACKAGE_ID": 119,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/my20/maps/nds/2026.06/MAP50470.bin"
    },
	{
        "ID": 124,
        "PACKAGE_ID": 120,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/low/maps/nds/2026.06/CP-TT-FCA.R1LOW.U-MAP.LATAM.NDS-16.0.0.zip"
    },
    {
        "ID": 125,
        "PACKAGE_ID": 121,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.LATAM.NDS-7.1.0.zip"
    },
    {
        "ID": 126,
        "PACKAGE_ID": 122,
        "NAME": "index.download_map",
        "URL_DESC": "https://download-cde.tomtom.com/cs/fca/r1/high/maps/nds/2026.06/CP-TT-FCA.R1HIGH.U-MAP.NAM.NDS-23.2.0.zip"
    },
    {
        "ID": 200,
        "PACKAGE_ID": 200,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1140/X100_Europe_1140.12581.zip"
    },
    {
        "ID": 201,
        "PACKAGE_ID": 201,
        "NAME": "TivoliNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/X100A_R6.3.zip"
    },
    {
        "ID": 202,
        "PACKAGE_ID": 202,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1140/X103_Europe_1140.12581.zip"
    },
    {
        "ID": 203,
        "PACKAGE_ID": 203,
        "NAME": "TivoliNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/X103_R6.3.zip"
    },
    {
        "ID": 204,
        "PACKAGE_ID": 204,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1140/C220_Europe_1140.12581.zip"
    },
    {
        "ID": 205,
        "PACKAGE_ID": 205,
        "NAME": "KorandoNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/C220A_C250A_R6.3.zip"
    },
    {
        "ID": 206,
        "PACKAGE_ID": 206,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Europe_1170.13183.zip"
    },
    {
        "ID": 207,
        "PACKAGE_ID": 207,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Russia_1170.13204.zip"
    },
    {
        "ID": 208,
        "PACKAGE_ID": 208,
        "NAME": "Rexton",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/R6.0.3/Y400EUAVNUpdate.UPA"
    },
    {
        "ID": 209,
        "PACKAGE_ID": 209,
        "NAME": "MUSSO_REXTON_SPORTS_SOFTWARE",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/R6.0.3/Q200EUAVNUpdate.UPA"
    },
    {
        "ID": 210,
        "PACKAGE_ID": 210,
        "NAME": "TIVOLI_SYSTEM_SOFTWARE",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/R6.0.3/X115EUAVNUpdate.UPA"
    },
    {
        "ID": 211,
        "PACKAGE_ID": 211,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Europe_1170.13183.zip"
    },
    {
        "ID": 212,
        "PACKAGE_ID": 212,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Russia_1170.13204.zip"
    },
    {
        "ID": 213,
        "PACKAGE_ID": 213,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Europe_1170.13183.zip"
    },
    {
        "ID": 214,
        "PACKAGE_ID": 214,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Russia_1170.13204.zip"
    },
    {
        "ID": 216,
        "PACKAGE_ID": 216,
        "NAME": "Y400",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/R6.0.3/Y400EUAVNUpdate.UPA"
    },
    {
        "ID": 217,
        "PACKAGE_ID": 217,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Europe_1170.13183.zip"
    },
    {
        "ID": 218,
        "PACKAGE_ID": 218,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Europe_1170.13183.zip"
    },
    {
        "ID": 219,
        "PACKAGE_ID": 219,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Russia_1170.13204.zip"
    },
    {
        "ID": 221,
        "PACKAGE_ID": 221,
        "NAME": "KorandoNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/R5.0.95/C300DEUAVNUpdate.UPA"
    },
    {
        "ID": 222,
        "PACKAGE_ID": 222,
        "NAME": "TivoliNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/R5.0.95/X150DEUAVNUpdate.UPA"
    },
    {
        "ID": 223,
        "PACKAGE_ID": 223,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.EUR.NDS-10.0.0.tar"
    },
    {
        "ID": 224,
        "PACKAGE_ID": 224,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.RUS.NDS-10.0.0.tar"
    },
    {
        "ID": 231,
        "PACKAGE_ID": 231,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 232,
        "PACKAGE_ID": 232,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.EUR.NDS-7.0.0.tar"
    },
    {
        "ID": 233,
        "PACKAGE_ID": 233,
        "NAME": "ALL NEW REXTON",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/V578/V578.zip"
    },
    {
        "ID": 234,
        "PACKAGE_ID": 234,
        "NAME": "Korando E-motion",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.0.85/E100NDEUAVNUpdate.upl"
    },
    {
        "ID": 235,
        "PACKAGE_ID": 235,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.EUR.NDS-10.0.0.tar"
    },
    {
        "ID": 236,
        "PACKAGE_ID": 236,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.RUS.NDS-10.0.0.tar"
    },
    {
        "ID": 237,
        "PACKAGE_ID": 237,
        "NAME": "MUSSO_REXTON_SPORTS_SOFTWARE",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.0.53/Q250NDEUAVNUpdate.upl"
    },
    {
        "ID": 238,
        "PACKAGE_ID": 238,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.RUS.NDS-10.0.0.tar"
    },
    {
        "ID": 239,
        "PACKAGE_ID": 239,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.EUR.NDS-10.0.0.tar"
    },
    {
        "ID": 240,
        "PACKAGE_ID": 240,
        "NAME": "TorresNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.1.14/J101NDEUAVNUpdate.upl"
    },
    {
        "ID": 241,
        "PACKAGE_ID": 241,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Europe_1170.13183.zip"
    },
    {
        "ID": 242,
        "PACKAGE_ID": 242,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/ttc/1170/SYMC_A_Russia_1170.13204.zip"
    },
    {
        "ID": 243,
        "PACKAGE_ID": 243,
        "NAME": "TivoliNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/R5.0.95/X150DEUAVNUpdate.UPA"
    },
    {
        "ID": 244,
        "PACKAGE_ID": 244,
        "NAME": "ALL NEW REXTON",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/V549/V549.zip"
    },
    {
        "ID": 245,
        "PACKAGE_ID": 245,
        "NAME": "MUSSO_REXTON_SPORTS_SOFTWARE",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/ttc/V549/V549.zip"
    },
    {
        "ID": 246,
        "PACKAGE_ID": 246,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.EUR.NDS-10.0.0.tar"
    },
    {
        "ID": 247,
        "PACKAGE_ID": 247,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/maps/nds/2026.03/CP-TT-Digen.SYMCB.P-MAP.RUS.NDS-10.0.0.tar"
    },
    {
        "ID": 248,
        "PACKAGE_ID": 248,
        "NAME": "ALL NEW REXTON",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.1.43/Y450NDEUAVNUpdate.upl"
    },
    {
        "ID": 249,
        "PACKAGE_ID": 249,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 250,
        "PACKAGE_ID": 250,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 300,
        "PACKAGE_ID": 300,
        "NAME": "Europe_Truck",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/maps/ttc/1175/CP-TT-CNHI.IVECO-NIS.UP-MAP.EUR.TTC-1175.2.zip"
    },
    {
        "ID": 301,
        "PACKAGE_ID": 301,
        "NAME": "Europe_Russia_Truck",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/maps/ttc/1175/CP-TT-CNHI.IVECO-NIS.UP-MAP.EUR.RUS.TTC-1175.2.zip"
    },
    {
        "ID": 302,
        "PACKAGE_ID": 302,
        "NAME": "Africa",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/maps/ttc/1175/CP-TT-CNHI.IVECO-NIS.UP-MAP.AFR.TTC-1175.1.zip"
    },
    {
        "ID": 303,
        "PACKAGE_ID": 303,
        "NAME": "Israel",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/maps/ttc/1175/CP-TT-CNHI.IVECO-NIS.UP-MAP.ISR.TTC-1175.2.zip"
    },
    {
        "ID": 304,
        "PACKAGE_ID": 304,
        "NAME": "Middle_East_Arabic",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/maps/ttc/1175/CP-TT-CNHI.IVECO-NIS.UP-MAP.MEA.TTC-1175.2.zip"
    },
    {
        "ID": 305,
        "PACKAGE_ID": 305,
        "NAME": "Oceania_truck",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/maps/ttc/1175/CP-TT-CNHI.IVECO-NIS.UP-MAP.OCE.TTC-1175.1.zip"
    },
    {
        "ID": 306,
        "PACKAGE_ID": 306,
        "NAME": "EMEA & APAC",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/ihp/maps/nds/2026.09/CP-TT-IVECO.IHP.U-MAP.EMEA-APAC.NDS-9.0.0.zip"
    },
    {
        "ID": 307,
        "PACKAGE_ID": 307,
        "NAME": "Americas",
        "URL_DESC": "https://download-cde.tomtom.com/cs/iveco/ihp/maps/nds/2026.09/CP-TT-IVECO.IHP.U-MAP.PAN-AM.NDS-9.0.0.zip"
    },
    {
        "ID": 309,
        "PACKAGE_ID": 309,
        "NAME": "South_Korea",
        "URL_DESC": "https://cde-korea-update.tomtom.com/IVECO/IHP/CP-TT-IVECO.IHP.U-MAP.KOR.NDS-9.0.0/CP-TT-IVECO.IHP.U-MAP.KOR.NDS-9.0.0.zip"
    },
    {
        "ID": 400,
        "PACKAGE_ID": 400,
        "NAME": "index.South_East_Asia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.ASEAN.TTC-15.0.0_update.zip"
    },
    {
        "ID": 401,
        "PACKAGE_ID": 401,
        "NAME": "index.Africa1",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.AFRICA.TTC-8.0.0_update.zip"
    },
    {
        "ID": 402,
        "PACKAGE_ID": 402,
        "NAME": "index.Latin_America_except_Chile",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.LAM.TTC-10.0.0_update.zip"
    },
    {
        "ID": 403,
        "PACKAGE_ID": 403,
        "NAME": "index.Latin_America_only_for_Chile",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.LATAMCHILE.TTC-7.0.0_update.zip"
    },
    {
        "ID": 404,
        "PACKAGE_ID": 404,
        "NAME": "index.Russia1",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.RUS.TTC-10.0.0_update.zip"
    },
    {
        "ID": 405,
        "PACKAGE_ID": 405,
        "NAME": "index.Europe_except_Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.EU.TTC-10.0.0_update.zip"
    },
    {
        "ID": 406,
        "PACKAGE_ID": 406,
        "NAME": "index.Israel",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.ISR.TTC-4.0.0_update.zip"
    },
    {
        "ID": 407,
        "PACKAGE_ID": 407,
        "NAME": "index.Middle_East_Asia_except_Israel",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.GCC.TTC-8.0.0_update.zip"
    },
    {
        "ID": 408,
        "PACKAGE_ID": 408,
        "NAME": "index.Oceania",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.AUS.TTC-10.0.0_update.zip"
    },
    {
        "ID": 409,
        "PACKAGE_ID": 409,
        "NAME": "index.North_America",
        "URL_DESC": "https://download-cde.tomtom.com/cs/melco/sda2/maps/ttc/CP-TT-MELCO.SDA2.T-MAP.NAS.TTC-8.0.0_update.zip"
    },
    {
        "ID": 501,
        "PACKAGE_ID": 501,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID153_Europe_1165.13125.zip"
    },
    {
        "ID": 502,
        "PACKAGE_ID": 502,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID161_Europe_1165.13125.zip"
    },
    {
        "ID": 503,
        "PACKAGE_ID": 503,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID163_Europe_1165.13125.zip"
    },
    {
        "ID": 504,
        "PACKAGE_ID": 504,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID171_Europe_1165.13125.zip"
    },
    {
        "ID": 505,
        "PACKAGE_ID": 505,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID173_Europe_1165.13125.zip"
    },
    {
        "ID": 506,
        "PACKAGE_ID": 506,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID181_Europe_1165.13125.zip"
    },
    {
        "ID": 508,
        "PACKAGE_ID": 508,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID183_Europe_1165.13125.zip"
    },
    {
        "ID": 509,
        "PACKAGE_ID": 509,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID191_Europe_1165.13125.zip"
    },
    {
        "ID": 510,
        "PACKAGE_ID": 510,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID201_Europe_1165.13125.zip"
    },
    {
        "ID": 511,
        "PACKAGE_ID": 511,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID203_Europe_1165.13125.zip"
    },
    {
        "ID": 512,
        "PACKAGE_ID": 512,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID211_Europe_1165.13125.zip"
    },
    {
        "ID": 513,
        "PACKAGE_ID": 513,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID213_Europe_1165.13125.zip"
    },
    {
        "ID": 514,
        "PACKAGE_ID": 514,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID221_Europe_1165.13125.zip"
    },
    {
        "ID": 515,
        "PACKAGE_ID": 515,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID223_Europe_1165.13125.zip"
    },
    {
        "ID": 516,
        "PACKAGE_ID": 516,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID231_Europe_1165.13125.zip"
    },
	{
        "ID": 517,
        "PACKAGE_ID": 517,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID233_Europe_1165.13125.zip"
    },
	{
        "ID": 518,
        "PACKAGE_ID": 518,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID241_Europe_1165.13125.zip"
    },
	{
        "ID": 519,
        "PACKAGE_ID": 519,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID243_Europe_1165.13125.zip"
    },
	{
        "ID": 520,
        "PACKAGE_ID": 520,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID251_Europe_1165.13125.zip"
    },
	{
        "ID": 521,
        "PACKAGE_ID": 521,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID253_Europe_1165.13125.zip"
    },
	{
        "ID": 522,
        "PACKAGE_ID": 522,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/mgn/maps/ttc/1165/MGN_SUID261_Europe_1165.13125.zip"
    },
    {
        "ID": 600,
        "PACKAGE_ID": 600,
        "NAME": "NAVI_80_NAVIGATION_SYSTEM_SOFTWARE",
        "URL_DESC": "https://download-cde.tomtom.com/cs/opel/navcore/TOMTOM.000"
    },
    {
        "ID": 601,
        "PACKAGE_ID": 601,
        "NAME": "NAVI_80_NAVIGATION_SYSTEM_SOFTWARE",
        "URL_DESC": "https://download-cde.tomtom.com/cs/opel/navcore/TOMTOM.000"
    },
    {
        "ID": 602,
        "PACKAGE_ID": 251,
        "NAME": "ALL NEW REXTON",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.00.24/Aupdate_Y470Q270_EU_R5.00.24.fmt;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.00.24/Aupdate_Y470Q270_EU_R5.00.24.zip"
    },
    {
        "ID": 604,
        "PACKAGE_ID": 253,
        "NAME": "KorandoNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.0.23/C330NDEUAVNUpdate.sig;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.0.23/C330NDEUAVNUpdate.upl"
    },
    {
        "ID": 606,
        "PACKAGE_ID": 255,
        "NAME": "TorresNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.21/Aupdate_J116_EU_R5.01.21.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.21/Aupdate_J116_EU_R5.01.21.fmt"
    },
    {
        "ID": 608,
        "PACKAGE_ID": 257,
        "NAME": "ActyonNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.22/Aupdate_J120_EU_R5.01.22.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.22/Aupdate_J120_EU_R5.01.22.fmt"
    },
    {
        "ID": 610,
        "PACKAGE_ID": 259,
        "NAME": "TORRESEVNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.42/Aupdate_U100_EU_R5.01.42.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.42/Aupdate_U100_EU_R5.01.42.fmt"
    },
    {
        "ID": 612,
        "PACKAGE_ID": 261,
        "NAME": "TivoliNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.0.23/X180NDEUAVNUpdate.sig;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.0.23/X180NDEUAVNUpdate.upl"
    },
    {
        "ID": 614,
        "PACKAGE_ID": 263,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.EUR.NDS-7.0.0.tar"
    },
    {
        "ID": 615,
        "PACKAGE_ID": 264,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 616,
        "PACKAGE_ID": 265,
        "NAME": "TorresNavigationSystemSoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.19/Aupdate_J110_EU_R5.01.19.zip"
    },
    {
        "ID": 617,
        "PACKAGE_ID": 266,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.EUR.NDS-7.0.0.tar"
    },
    {
        "ID": 618,
        "PACKAGE_ID": 267,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 619,
        "PACKAGE_ID": 268,
        "NAME": "TORRESHybridNavigationsystemsoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.11/Aupdate_J140_EU_R5.01.11.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.11/Aupdate_J140_EU_R5.01.11.fmt"
    },
    {
        "ID": 620,
        "PACKAGE_ID": 269,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.EUR.NDS-7.0.0.tar"
    },
    {
        "ID": 621,
        "PACKAGE_ID": 270,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 622,
        "PACKAGE_ID": 271,
        "NAME": "ActyonHybridNavigationsystemsoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.06/Aupdate_J145_EU_R5.01.06.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.06/Aupdate_J145_EU_R5.01.06.fmt"
    },
    {
        "ID": 623,
        "PACKAGE_ID": 272,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.EUR.NDS-7.0.0.tar"
    },
    {
        "ID": 624,
        "PACKAGE_ID": 273,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 625,
        "PACKAGE_ID": 274,
        "NAME": "MUSSOEVNavigationsystemsoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.11/Aupdate_O100_EU_R5.01.11.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.11/Aupdate_O100_EU_R5.01.11.fmt"
    },
	{
        "ID": 626,
        "PACKAGE_ID": 275,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.EUR.NDS-7.0.0.tar"
    },
    {
        "ID": 627,
        "PACKAGE_ID": 276,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 628,
        "PACKAGE_ID": 277,
        "NAME": "TORRESEVNavigationsystemsoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.09/Aupdate_U105_EU_R5.01.09.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.09/Aupdate_U105_EU_R5.01.09.fmt"
    },
	{
        "ID": 629,
        "PACKAGE_ID": 278,
        "NAME": "Europe",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.EUR.NDS-7.0.0.tar"
    },
    {
        "ID": 630,
        "PACKAGE_ID": 279,
        "NAME": "Russia",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/y461/maps/nds/2026.03/CP-TT-Digen.SYMCC.P-MAP.RUS.NDS-7.0.0.tar"
    },
    {
        "ID": 631,
        "PACKAGE_ID": 280,
        "NAME": "TORRESNavigationsystemsoftware",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.07/Aupdate_J116Y_EU_R5.01.07.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.07/Aupdate_J116Y_EU_R5.01.07.fmt"
    },
    {
        "ID": 632,
        "PACKAGE_ID": 281,
        "NAME": "MUSSO_REXTON_SPORTS_SOFTWARE",
        "URL_DESC": "https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.07/Aupdate_Q300_EU_R5.01.07.zip;https://download-cde.tomtom.com/cs/digen/softwares/nds/R5.01.07/Aupdate_Q300_EU_R5.01.07.fmt"
    }
	
]